import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { TranslationService } from './modules/i18n';
// language list
import { locale as enLang } from './modules/i18n/vocabs/en';
import { locale as arLang } from './modules/i18n/vocabs/ar';
import { ThemeModeService } from './_metronic/partials/layout/theme-mode-switcher/theme-mode.service';
import { UiHelperService } from './_metronic/services/ui-helper.service';
import { DataContextService } from './_metronic/services/data-context.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ResultObject } from './_metronic/shared/dtos/result-object-dto';
import { UserDTO } from './_metronic/shared/dtos/user-dto';
import { AuthService } from './modules/auth';

@Component({
  // tslint:disable-next-line:component-selector
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'body[root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  constructor(
    private translationService: TranslationService,
    private modeService: ThemeModeService,
    private uiHelper:UiHelperService,
    private dataContext:DataContextService,
    private spinner:NgxSpinnerService,
    private auth:AuthService,
    private ch:ChangeDetectorRef
  ) {
    // register translations
    this.translationService.loadTranslations(
      enLang,
      arLang
    );
  }

  ngOnInit() {
    this.modeService.init();
    this.getProfileUser()
  }

  private getProfileUser(){
    this.spinner.show()
    if(this.auth.getToken()){
      const profileSub = this.dataContext.GetData('/dashboard/profile').subscribe(
        {
          next:(result) =>{
            const response = <ResultObject<UserDTO>>result
            if(response.status === 200){
              this.auth.currentUser.next(response.data)
            }
            this.spinner.hide()
            profileSub.unsubscribe()
            this.ch.detectChanges()
          },
          error:(err) =>{
            this.uiHelper.toastrError(err.error.message)
            this.spinner.hide()
            profileSub.unsubscribe()
            this.ch.detectChanges()
          }
        }
      )
    }
  }
}
